import { toast } from "react-toastify";
import { apiSlice } from ".";


const contactsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({

    getContacts: builder.query({
      query: (agtid) => `/Contacts360/Contact?agtid=${agtid}&agcid=`,
    }),
  }),
});

export const { useGetContactsQuery } = contactsApi;
